import {useMemo} from 'react'

import Tooltip from './Tooltip'

export default function FormFieldLaitevalinta (props) {
  const numRows = useMemo(() => (
    props.value?.length || 0
  ), [props.value])
  return (
    <div className="wp-block-gds-lead-form__form-field wp-block-gds-lead-form__form-field--laitevalinta">
      {props.label && (
        <label>
          {props.label}{props.required ? '*' : ''}
          {props.tooltip && <Tooltip>{props.tooltip}</Tooltip>}
        </label>
      )}
      {/* <input
        type="text"
        required={props.required}
        value={props.value}
        onChange={e => props.onChange?.(e.target.value)}
      /> */}
      <div className="wp-block-gds-lead-form__form-field--laitevalinta__row">
        <label>Laitetyyppi</label>
        <label>Kokoluokka (kg)</label>
        <label>Laitteiden määrä</label>
      </div>
      {props.value?.map((row, index) => (
        <div key={index} className="wp-block-gds-lead-form__form-field--laitevalinta__row">
          <select
            value={row['Tyyppi']}
            onChange={e => {
              row['Tyyppi'] = event.target.value
              props.onChange?.(props.value)
            }}
          >
            {props.options.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          <input
            type="number"
            value={row['Kokoluokka']}
            onChange={e => {
              row['Kokoluokka'] = e.target.value
              props.onChange?.(props.value)
            }}
          />
          <input
            type="number"
            value={row['Laitteiden määrä']}
            onChange={e => {
              row['Laitteiden määrä'] = e.target.value
              props.onChange?.(props.value)
            }}
          />
          <button
            className="wp-block-gds-lead-form__form-field--laitevalinta__remove-row"
            onClick={() => {
              props.value.splice(index, 1)
              props.onChange?.(props.value)
            }}
          >
            &times;
          </button>
        </div>
      ))}
      <div className="wp-block-gds-lead-form__form-field--laitevalinta__row">
        <select
          key={numRows}
          value=""
          onChange={e => {
            const newValue = props.value || []
            newValue.push({
              'Tyyppi': e.target.value,
              'Kokoluokka': '',
              'Laitteiden määrä': '',
            })
            props.onChange?.(newValue)
          }}
        >
          <option value="">Valitse laitetyyppi</option>
          {props.options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
        <input type="number" disabled />
        <input type="number" disabled />
        <button
            className="wp-block-gds-lead-form__form-field--laitevalinta__remove-row hidden"
          >
            &times;
          </button>
      </div>
    </div>
  )
}
